import React from 'react'

const TopSpeakers = ({ speakers }: any) => {
  return (
    <div className=''>
      <h2 className='md:text-[32px] text-[18px] max-sm:text-center  font-bold md:mb-[50px] mb-[24px] text-[#001A3D]'>
        Top speakers
      </h2>
      {speakers.map((speaker) => (
        <div key={speaker.id} className='flex items-center gap-[10px] my-10'>
          <div
            className='md:h-[80px] md:w-[80px] rounded-full'
            style={{
              background: `url(${speaker.avatar}) lightgray 50% / cover no-repeat`,
            }}
          />
          <div className='flex flex-col '>
            <p className='font-semibold text-[#001A3D] pb-0 mb-0'>
              {speaker.name}
            </p>
            <span className='text-[#001A3D]'>{speaker.type}</span>
          </div>
        </div>
      ))}
    </div>
  )
}

export default TopSpeakers
